import axios from '@/plugins/axios';
import { getDeviceId } from '../../js/utils/service-helpers';
import { Device } from 'framework7';

export default {
    namespaced: true,

    actions: {
        async requestPhoneValidation({}, { phone, name, captcha_code = '' } = {}) {
            let response = null;
            try {
                const { data } = await axios.post('/front/customer/register', { phone: '+7' + phone.replace(/[^\d]/g, '').slice(0, 10), name, captcha_code, sendSms: false });
                response = data;
            } catch (e) {
                response = {
                    message: e.message
                };
            }
            return response;
        },

        async repeatRequest({}, { userInfo }) {
            let response = null;
            try {
                const { data } = await axios.post('/front/customer/register', { phone: userInfo.phone, name: userInfo.name, sendSms: true });
                response = data;
            } catch (e) {
                response = {
                    message: e.message
                };
            }
            return response;
        },

        async validateSmsCode({}, { customer_id, code }) {
            let response = null;
            try {
                let resp = null;
                const device_id = await getDeviceId();
                if(device_id) {
                    resp = await axios.post('/front/customer/verification-device', { customer_id, device_id, code });
                } else {
                    resp = await axios.post('/front/customer/verification', { customer_id, code });
                }
                response = resp.data;
            } catch (e) {
                response = {
                    message: e.message
                };
            }
            return response;
        },
        // Telegram Auth - инициализация (новый безопасный метод)
        async telegramAuthInit({}, { phone }) {
            let response = null;
            try {
                const { data } = await axios.post('/front/customer/telegram-auth-init', {
                    phone: '+7' + phone.replace(/[^\d]/g, '').slice(0, 10)
                });
                response = data;
            } catch (e) {
                console.log(e, "ERROR");
                
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // Telegram Auth - проверка статуса
        async telegramAuthCheckStatus({}, { request_id }) {
            let response = null;
            try {
                const device_id = await getDeviceId();
                const { data } = await axios.post(`/front/customer/telegram-auth-status/${request_id}`, {
                    device_id
                });
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // VK Auth - инициализация
        async vkAuthInit({}, { phone }) {
            let response = null;
            try {
                const { data } = await axios.post('/front/customer/vk-auth-init', {
                    phone: '+7' + phone.replace(/[^\d]/g, '').slice(0, 10)
                });
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // VK Auth - проверка статуса
        async vkAuthCheckStatus({}, { request_id }) {
            let response = null;
            try {
                const device_id = await getDeviceId();
                const { data } = await axios.post(`/front/customer/vk-auth-status/${request_id}`, {
                    device_id
                });
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // Telegram Auth (старый метод - для обратной совместимости)
        async telegramAuth({}, { token }) {
            let response = null;
            try {
                const device_id = await getDeviceId();
                const { data } = await axios.post('/front/customer/telegram-auth', {
                    token,
                    device_id
                });
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // FlashCall - запрос звонка
        async requestFlashCall({}, { phone, name }) {
            let response = null;
            try {
                const { data } = await axios.post(
                    '/front/customer/flashcall-register',
                    {
                        phone: '+7' + phone.replace(/[^\d]/g, '').slice(0, 10),
                        name
                    },
                    { __skipErrorUI: true }
                );
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },

        // FlashCall - верификация кода
        async validateFlashCallCode({}, { customer_id, code }) {
            let response = null;
            try {
                const device_id = await getDeviceId();
                const { data } = await axios.post(
                    '/front/customer/flashcall-verification',
                    {
                        customer_id,
                        code,
                        device_id
                    },
                    { __skipErrorUI: true }
                );
                response = data;
            } catch (e) {
                response = {
                    error: e.response?.data?.error || e.response?.data?.message || e.message
                };
            }
            return response;
        },
    },

}
